<template>
  <div class="other-template" theme>
    <div id="other-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'other',
      parts: [
        {
          elem: '#other-content',
          htmlFile: 'other'
        }
      ]
    }
  }
}
</script>
